import React from 'react';
import { FadeIn } from './FadeIn';
interface BooksSectionProps {
  onBuyNow?: () => void;
}
const books = [{
  title: '40 Days Prayer Guide',
  description: 'A powerful 40-day journey of prayer and devotion designed to deepen your relationship with God and transform your prayer life.',
  price: '$14.99',
  cover: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?q=80&w=600&auto=format&fit=crop'
}];
export function BooksSection({
  onBuyNow
}: BooksSectionProps) {
  return <section id="books" className="py-24 md:py-32 bg-cream" data-id="element-36">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-37">
        <FadeIn className="text-center mb-16 md:mb-24" data-id="element-38">
          <span className="text-gold font-semibold tracking-[0.2em] text-sm uppercase mb-4 block" data-id="element-39">
            Resources
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-charcoal" data-id="element-40">
            Life-Changing Books
          </h2>
          <p className="text-charcoal/70 font-inter text-lg mt-6 max-w-xl mx-auto" data-id="element-41">
            Explore our life-changing books to deepen your faith and walk with
            God.
          </p>
        </FadeIn>

        <div className="flex justify-center" data-id="element-42">
          {books.map((book, index) => <FadeIn key={book.title} delay={index * 0.2} className="flex flex-col md:flex-row items-center gap-12 max-w-3xl" data-id="element-43">
              <div className="relative w-full max-w-[280px] aspect-[2/3] group perspective-1000 shrink-0" data-id="element-44">
                {/* Decorative shadow */}
                <div className="absolute -inset-2 bg-charcoal/10 blur-xl rounded-xl group-hover:bg-gold/20 transition-colors duration-500" data-id="element-45" />

                {/* Book Cover */}
                <div className="relative w-full h-full bg-charcoal border border-gold/30 shadow-2xl transform transition-transform duration-500 group-hover:-translate-y-2" data-id="element-46">
                  <img src={book.cover} alt={book.title} className="w-full h-full object-cover opacity-90 mix-blend-luminosity group-hover:mix-blend-normal transition-all duration-500" data-id="element-47" />
                  <div className="absolute inset-0 border-l-4 border-white/20 mix-blend-overlay" data-id="element-48" />
                </div>
              </div>

              <div className="text-center md:text-left" data-id="element-49">
                <h3 className="text-4xl font-playfair font-bold text-charcoal mb-4" data-id="element-50">
                  {book.title}
                </h3>
                <p className="text-charcoal/70 font-inter mb-6 text-lg leading-relaxed" data-id="element-51">
                  {book.description}
                </p>
                <div className="text-3xl font-playfair font-bold text-gold mb-8" data-id="element-52">
                  {book.price}
                </div>
                <button onClick={onBuyNow} className="inline-block px-10 py-4 bg-gold hover:bg-goldLight text-dark font-semibold tracking-wide transition-colors rounded-sm cursor-pointer" data-id="element-53">
                  Buy Now
                </button>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}